// APP
export const APP_NAME = process.env.REACT_APP_NAME ?? "APP_NAME_MISSING";
export const APP_VERSION = process.env.REACT_APP_VERSION ?? "undefined";
export const APP_BUILD_TIME = process.env.REACT_APP_BUILD_TIME ?? "undefined";

export const TIME_UPDATE_INTERVAL = 1000 * 60;
